import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './i18n/config';
import App from './App';
import './index.css';

// Performance monitoring (basic instrumentation)
if (typeof window !== 'undefined' && 'performance' in window) {
  window.addEventListener('load', () => {
    // Log Core Web Vitals when available
    try {
      const navigation = performance.getEntriesByType('navigation')[0] as PerformanceNavigationTiming | undefined;
      if (navigation) {
        console.log('[Performance] DOM Content Loaded:', navigation.domContentLoadedEventEnd - navigation.startTime, 'ms');
        console.log('[Performance] Load Complete:', navigation.loadEventEnd - navigation.startTime, 'ms');
      }
    } catch {
      // Silently fail if performance API not fully supported
    }
  });
}

// Service worker registration for PWA (optional, can be enabled later)
// if ('serviceWorker' in navigator) {
//   window.addEventListener('load', () => {
//     navigator.serviceWorker.register('/sw.js').catch(() => {});
//   });
// }

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Root element not found');
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>
);
